<template>
  <div class="body">
    <Home-Header :navindex="4"></Home-Header>
     <Home-Swiper :slideindex="2"></Home-Swiper>
    <Home-QA  :bg="bgfff"></Home-QA>
    <Home-Safe></Home-Safe>
    <Home-Floatbar></Home-Floatbar>
    <Home-Footer></Home-Footer>
    <Home-Footerfrom></Home-Footerfrom>
    <a id="newBridge-left"  href="http://pkt.zoosnet.net/LR/Chatpre.aspx?id=PKT58642380&lng=cn"  rel='nofollow' target="_blank" ></a>

  </div>
</template>

<script>
import HomeHeader from '../common/Header'
import HomeSwiper from '../common/Swiper'
import HomeQA from '../common/QA'
import HomeSafe from '../common/Safe'
import HomeFloatbar from '../common/Floatbar'
import HomeFooter from '../common/Footer'
import HomeFooterfrom from '../common/Footerfrom'
export default {
  name: 'Problem',
  metaInfo: {
    title: '代理记账问题汇总-上海机巧科技有限公司',
    meta: [
      { name: 'keywords', content: '代理记账流程_代理记账费用_代理记账公司' },
      { name: 'description', content: '上海机巧科技有限公司常见问题栏目为你讲解：企业对代理记账的需求,代理注册公司的流程以及注意事项,代理记账的费用以及收费标准相关问题。' }
    ]
  },
  components: {
    HomeHeader, HomeSwiper, HomeQA, HomeSafe, HomeFloatbar, HomeFooter, HomeFooterfrom
  },
  data () {
    return {
      bgf8f6f9: 'bgf8f6f9',
      bgfff: 'bgfff'
    }
  },
  mounted () {
  }
}
// eslint-disable-next-line eol-last
</script>



// WEBPACK FOOTER //
// src/pages/Problem/Problem.vue